<template>
    <div :class="['relative w-full ', classes]">
        <div @click="toggleDropdown" v-if="activeTab" class="cursor-pointer py-2 px-3 bg-gray-200 rounded-md w-full flex justify-between">
            {{ $__(tabs[activeTab].translationKey) }}
            <div :class="[dropdownOpen ? '-rotate-90' : 'rotate-90']">
                <Arrow
                    class="color-primary"
                />
            </div>
        </div>
        <div v-if="dropdownOpen" class="bg-white rounded-md pt-4 mt-1 absolute w-full shadow-lg z-10">
            <div @click="switchTab(key)" :class="['px-4 pb-4 tab', tab.active ? 'color-primary' : '']" v-for="(tab, key) in tabs">
                {{ $__(tab.translationKey) }}
            </div>
        </div>
    </div>
</template>

<script>
import Arrow from "@/Components/Icons/Arrow";
export default {
    data: () => ({
        dropdownOpen: false,
    }),
    components: {Arrow},
    props: ['tabs', 'activeTab', 'classes'],
    methods: {
        switchTab(key) {
            this.$emit('switchTab', key)
        },
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        }
    }
}
</script>
